import React from 'react';
import {
    MenuItemLink,
    WithPermission
} from 'admin-on-rest';
import AccountButton from '../buttons/AccountButton';
import LogoutButton from '../buttons/LogoutButton';

import HomeIcon from 'material-ui/svg-icons/action/home';
import SystemIcon from 'material-ui/svg-icons/hardware/device-hub';
import SystemsReportIcon from 'material-ui/svg-icons/editor/insert-chart';
import SysOpIcon from 'material-ui/svg-icons/social/people';
import SysAdminIcon from 'material-ui/svg-icons/social/person';

/**
 * The Sidebar Menu. Displays links based on User permission.
 *
 * @param onMenuTap
 * @return {*}
 * @constructor
 */
export const MainMenu = ({onMenuTap}) => {

    const authMethod = localStorage.getItem('auth_method');

    return (
        <div>
            <MenuItemLink to="/" primaryText="Dashboard" leftIcon={<HomeIcon/>} onClick={onMenuTap}
                          className="menu-link"/>
            <WithPermission value={['sys_op']}>
                <MenuItemLink to="/Systems" primaryText="Systems" leftIcon={<SystemIcon/>} onClick={onMenuTap}
                              className="menu-link"/>
                <MenuItemLink to="/SystemsReport" primaryText="Systems Report" leftIcon={<SystemsReportIcon/>}
                              onClick={onMenuTap} className="menu-link"/>
                <MenuItemLink to="/SysOps" primaryText="Sysops" leftIcon={<SysOpIcon/>} onClick={onMenuTap}
                              className="menu-link"/>
                <MenuItemLink to="/SysAdmins" primaryText="Sysadmins" leftIcon={<SysAdminIcon/>} onClick={onMenuTap}
                              className="menu-link"/>
                <MenuItemLink to="/SysUsers" primaryText="Sysusers" leftIcon={<SysAdminIcon/>} onClick={onMenuTap}
                              className="menu-link"/>
            </WithPermission>

            {authMethod === 'kc-' &&
                <AccountButton/>
            }
            <LogoutButton/>
        </div>
    )
};



// WEBPACK FOOTER //
// ./src/Fuse/global/menu.js